/* 孫吳傳・第 4 章：陽人（191 年）
 * 西邊是陽人城（方形小城，東牆有城門），東邊是胡軫、華雄的營。梁東之戰後散落的部隊躲在四周的林子與村子裡。 */
export const CITY = { x: 2400, y: 2800, hw: 850, hh: 650 };
const T = 40, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATE = [E, CITY.y];
export default {
  id: 'yangren', name: '陽人', W: 8400, H: 5600, seed: 1911,
  bases: [[2300, 2800], [7000, 2800]], // 陽人城、胡軫營
  walls: [
    [CITY.x, N, CITY.hw + T, T], [CITY.x, S, CITY.hw + T, T], [Wx, CITY.y, T, CITY.hh],
    [E, (N + GATE[1] - 120) / 2, T, (GATE[1] - 120 - N) / 2], [E, (S + GATE[1] + 120) / 2, T, (S - GATE[1] - 120) / 2], // 東牆，中間是城門
  ],
  roads: [
    { pts: [[2300, 2800], [GATE[0] + 300, 2800], [4800, 2850], [6000, 2800], [7000, 2800]], w: 160 },
    { pts: [[GATE[0] + 300, 2800], [3900, 1700], [4200, 1000]], w: 90 },
    { pts: [[GATE[0] + 300, 2800], [3900, 3900], [4300, 4600]], w: 90 },
    { pts: [[4800, 2850], [5200, 2000]], w: 80 },
  ],
  rocks: [[1300, 1300, 300, 160], [5600, 1300, 420, 200], [5800, 4300, 420, 220], [1200, 4500, 260, 150]],
  woods: 0.45,
  sight: 0.7,
  clearings: [[CITY.x, CITY.y, 1000], [GATE[0] + 450, GATE[1], 420], [1200, 1100, 300], [1000, 4300, 300]],
  villages: [{ x: CITY.x - 100, y: CITY.y, n: 8, r: 520 }, { x: 4300, y: 4700, n: 4, r: 300 }],
  tents: [{ x: 7000, y: 2800, n: 12, r: 500, chief: true, col: '#5a3a30', flag: '胡' }],
  grass: [[4200, 1100, 240, 110], [5200, 2000, 220, 100], [3300, 1300, 220, 100], [3300, 4300, 220, 100]],
};
